// extracted by mini-css-extract-plugin
module.exports = {"Contact":"contact-module--Contact--2IHy3"};